import React, { useEffect, useState } from 'react';
import { Image, View } from 'react-native';
import { Container, Dialog, Spacing, Typography } from 'components/src';
import { createUseStyles, Platform, useGetUserGetUserProfile } from 'core/src';
import { UpdatePassword } from '../../templates/profileScreen/components';
import AsyncStorage from '@react-native-async-storage/async-storage';

const Staging = () => {
  const { styles, colors } = useStyles();
  const { data, isFetched } = useGetUserGetUserProfile();
  const [key, setKey] = useState('');

  useEffect(() => {
    const fetchModalVisibility = async () => {
      try {
        const value = await AsyncStorage.getItem('checkPassword');
        if (value !== null) {
          setKey(value);
        }
      } catch (error) {
        console.error('Failed to retrieve data from AsyncStorage', error);
      }
    };

    fetchModalVisibility();
  }, []);

  return (
    <Container>
      <Dialog
        // handleModalClose={handleModalClose}
        classesIn={styles.modalContent}
        classesOut={styles.modalContainer}
        modalVisible={key === 'false' ? true : false}
        animationType={'fade'}
      >
        <UpdatePassword />
      </Dialog>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
        }}
      >
        {isFetched && (
          <>
            <View style={styles.container}>
              <View style={styles.imageContainer}>
                <Image
                  source={
                    data?.data?.group === 'پزشکت'
                      ? require('../../../../assets/src/images/pezeshket-logo.png')
                      : data?.data?.group === 'همکده'
                        ? require('../../../../assets/src/images/hamkadeh-text-logo.png')
                        : require('../../../../assets/src/images/logo.png')
                  }
                  style={styles.image}
                  resizeMode="center"
                />
              </View>
              <Spacing vertical={8} />
              <View>
                <Typography
                  text={data?.data?.nameAndFamily}
                  size={30}
                  weight="bold"
                  color={colors.color01}
                />
              </View>
            </View>
          </>
        )}
      </View>
    </Container>
  );
};
const useStyles = createUseStyles(({ colors, theme }) => ({
  container: {
    alignItems: 'center',
  },
  modalContainer: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },

  modalContent: {
    width: Platform.isDesktop ? '50%' : '90%',
    height: 550,
  },
  imageContainer: {
    width: 300,
    height: 300,
    backgroundColor: '#fff',
    borderWidth: theme === 'white' ? 1 : 0,
    borderRadius: 200,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  image: { width: 230, height: 230 },
}));

export { Staging };
